PluginChromeView = require 'app/scripts/views/plugin/plugin-chrome-view'

module.exports = class PluginModalView extends PluginChromeView
  initialize: ({ @content }) ->
    @retain(@content)

  className: 'plugin-modal'
